import registerUserback from 'libs/userback';
import { auth } from 'utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { $user, $auth, $app } from 'signals/global.signals';
import displayError from 'utils/displayError';
import { handleRefreshDbUser } from 'components/global/_helpers/global.helpers';

const registerFirebaseAuthListener = () => onAuthStateChanged(auth, async (authUser) => {
  if ($user.value.isCreatingUser) {
    if (authUser) {
      $auth.update({
        ...authUser,
        isSignedIn: true,
      });
    }
    return;
  } // Do not try to do anything if we are creating a user

  $app.update({ isLoading: true });
  try {
    if (authUser) {
      $auth.update({
        ...authUser,
        isSignedIn: true,
      });
      await handleRefreshDbUser();
    }
  } catch (e) {
    displayError({
      message: 'Failed to authenticate user. Please try logging in again.',
      title: 'Authentication Error',
    });
  } finally {
    // handleCleanUpCommonSignals();
    $app.update({ isLoading: false });
  }
});

export default {
  registerFirebaseAuthListener,
  registerUserback,
};
